function fetchFile(url, key) {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.onload = () => {
      if (request.status !== 200) {
        reject(new Error(this.statusText));
      }
      let reader = new FileReader();
      reader.onloadend = () => {
        resolve({ file: reader.result, key: key });
      };
      reader.readAsArrayBuffer(request.response);
    };
    request.onerror = () => {
      reject(new Error("XMLHttpRequest Error: " + request.statusText));
    };
    request.open("GET", url, true);
    request.responseType = "blob";
    request.send();
  });
}

export default fetchFile;



// WEBPACK FOOTER //
// ./src/pdf/fetchFile.js